import styled from "styled-components";
import { Input } from "./Input";

export default styled(Input).attrs({
	as: "textarea",
	translate: "no",
})``;
